import "../scss/style.scss";

// JS Components
import "./scripts/_navbar.js";
import "./scripts/_megamenu.js";
import "./scripts/_burger.js";
import "./scripts/_scrolldirection.js";
import "./scripts/_lang.js";
import "./scripts/_timeline.js";
import "./scripts/_founders.js";
import "./scripts/_marker.js";
import "./scripts/_label.js";
import "./scripts/_accordion.js";
import "./scripts/_swiper.js";
import "./scripts/_video.js";
import "./scripts/_counter.js";
import "./scripts/_lightgallery.js";
import "./scripts/_wow.js";

document.addEventListener("DOMContentLoaded", function () {

});